import * as XLSX from "xlsx";
import { DownloadBlobFile } from "../../Shared/Utils/fileHelpers";

const pushSectionTitle = (rows, title) => {
  rows.push([title]);
  rows.push([]);
};

const pushKeyValueRows = (rows, entries = []) => {
  entries.forEach((entry) => rows.push([entry.label, entry.value]));
  rows.push([]);
};

const pushListRows = (rows, items = [], ordered = false) => {
  items.forEach((item, index) => rows.push([ordered ? index + 1 : "-", item]));
  rows.push([]);
};

const pushNumericalRows = (rows, numericalResults) => {
  if (!numericalResults?.rows?.length) return;

  if (numericalResults.description) {
    rows.push([numericalResults.description]);
  }

  rows.push([
    numericalResults.columns.item,
    numericalResults.columns.metric,
    numericalResults.columns.value,
    numericalResults.columns.change,
  ]);
  numericalResults.rows.forEach((row) => {
    rows.push([row.item, row.metric, row.value, row.change]);
  });
  rows.push([]);
};

export const exportReportToExcel = ({ filename, model, t }) => {
  const language = model.language;
  const rows = [[model.reportTitle], [model.reportSubtitle || ""], [model.reportDescription || ""], []];

  if (model.aiServiceFailure) {
    pushSectionTitle(rows, t("reports.aiAnalysisFailed", language === "en" ? "AI analysis failed" : "فشل التحليل الذكي"));
    pushListRows(rows, [model.userFacingAiError]);
  } else {
    pushSectionTitle(rows, t("reports.reportMeta", language === "en" ? "Report Meta" : "بيانات التقرير"));
    pushKeyValueRows(rows, model.reportMeta);

    pushSectionTitle(rows, t("reports.basicReportData", language === "en" ? "Basic Report Data" : "بيانات التقرير الأساسية"));
    pushKeyValueRows(rows, model.basicReportData);

    pushSectionTitle(rows, t("reports.numericalResults", language === "en" ? "Numerical Results" : "نتائج رقمية"));
    pushNumericalRows(rows, model.numericalResults);

    pushSectionTitle(rows, t("reports.analysis", language === "en" ? "Analysis" : "التحليل"));
    pushListRows(rows, model.analysis, true);

    pushSectionTitle(
      rows,
      t("reports.recommendationsAndAlerts", language === "en" ? "Recommendations & Alerts" : "التوصيات والتنبيهات")
    );
    pushListRows(rows, model.recommendationsAndAlerts);
  }

  const worksheet = XLSX.utils.aoa_to_sheet(rows);
  worksheet["!cols"] = [{ wch: 10 }, { wch: 34 }, { wch: 28 }, { wch: 24 }];

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Report");
  const buffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

  DownloadBlobFile(
    new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    }),
    filename
  );
};
